import Joi from "joi";

export const loginSchema = Joi.object({
  Email: Joi.string().min(3).label("Username").messages({
    "string.min": "Username duhet të përmbaj së paku 3 karaktere.",
    "string.empty": "Username duhet të përmbaj së paku 3 karaktere.",
  }),
  Password: Joi.string().min(3).label("Password").messages({
    "string.min": "Password duhet të përmbaj së paku 3 karaktere.",
    "string.empty": "Password duhet të përmbaj së paku 3 karaktere.",
  }),
});
